import { trapFocus, removeTrapFocus } from '../helper/functions.js';

class SidebarDrawer extends HTMLElement {
  constructor() {
    super();

    this._overlay = this.querySelector('.sidebar-drawer-overlay');
    this._lastFocusedElement = null;
    this.bindToggles();
  }

  bindToggles() {
    // Get the unique ID for this drawer
    const drawerId = this.id;

    // Target only triggers that target this specific drawer instance
    this._triggers = document.querySelectorAll(`[data-drawer-target="${drawerId}"]`);

    this._triggers.forEach((trigger) => {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.trigger(this);
      });
    });

    this._overlay.addEventListener('click', (event) => {
      event.preventDefault();
      this.trigger(this);
    });

    // Also add click event to close button
    const closeButton = this.querySelector('.drawer__close');
    if (closeButton) {
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.trigger(this);
      });
    }

    // Add keyboard event listener for Escape key
    this.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.isOpen()) {
      event.preventDefault();
      this.trigger(this);
    }
  }

  isOpen() {
    return this.hasAttribute('open');
  }

  trigger(triggeredElement) {
    if (this.isOpen()) {
      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
      this.classList.add('translate-x-full');
      document.body.classList.remove('overflow-hidden');

      // Remove focus trap and restore focus to the last focused element
      removeTrapFocus(this._lastFocusedElement);
      this._lastFocusedElement = null;

      // Update ARIA attributes on triggers
      this._triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    } else {
      // Store the currently focused element before opening the drawer
      this._lastFocusedElement = document.activeElement;

      this.setAttribute('open', '');
      this.classList.remove('translate-x-full');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');

      // Trap focus within the drawer
      trapFocus(this);

      // Update ARIA attributes on triggers
      this._triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'true');
      });
    }
  }
}

customElements.define('sidebar-drawer', SidebarDrawer);
